import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Coffee({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M4 5.99998C4 5.63179 4.29848 5.33331 4.66667 5.33331H16.6667C17.0349 5.33331 17.3333 5.63179 17.3333 5.99998V8.6664C17.8904 8.24794 18.5829 7.99998 19.3333 7.99998H20C21.4728 7.99998 22.6667 9.19389 22.6667 10.6666C22.6667 12.1394 21.4728 13.3333 20 13.3333H18.6667V12H20C20.7364 12 21.3333 11.403 21.3333 10.6666C21.3333 9.93027 20.7364 9.33331 20 9.33331H19.3333C18.2288 9.33331 17.3333 10.2287 17.3333 11.3333V13.3333C17.3333 15.1743 15.8409 16.6666 14 16.6666H7.33333C5.49238 16.6666 4 15.1743 4 13.3333V5.99998ZM16 6.66665V13.3333C16 14.4379 15.1046 15.3333 14 15.3333H7.33333C6.22876 15.3333 5.33333 14.4379 5.33333 13.3333V6.66665H16Z"
        fill={iconColor}
      />
      <Path d="M4 20H17.3333V18.6666H4V20Z" fill={iconColor} />
    </Svg>
  );
}
